import FormattedMessage from 'I18n/components/FormattedMessage';
import { CANDY_APPLE, EERIE } from 'HubStyleTokens/colors';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import { useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewTextInput({
  dataTestId,
  fieldKey,
  label,
  placeholder,
  resize,
  rows,
  tooltip
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review,
    validationErrors
  } = useReviewContext();
  const {
    minCharacters,
    maxCharacters,
    required
  } = getFieldValidation('content', fieldKey);
  const minCharactersError = !!validationErrors.find(({
    error,
    fieldKey: errorFieldKey,
    fieldType
  }) => error === 'minCharacters' && fieldType === 'content' && errorFieldKey === fieldKey);
  const maxCharactersError = !!validationErrors.find(({
    error,
    fieldKey: errorFieldKey,
    fieldType
  }) => error === 'maxCharacters' && fieldType === 'content' && errorFieldKey === fieldKey);
  const showError = !!review.content[fieldKey] && (minCharactersError || maxCharactersError);
  const renderTextArea = ({
    onChange,
    value
  }) => /*#__PURE__*/_jsx(UITextArea, {
    "data-test-id": dataTestId,
    error: showError,
    onChange: e => {
      onUpdateReview({
        content: {
          [fieldKey]: e.target.value
        }
      });
      if (onChange) {
        onChange(e);
      }
    },
    placeholder: placeholder,
    resize: resize,
    rows: rows,
    value: value
  });
  const renderCharacterCounterLabel = count => {
    if (minCharactersError) {
      return /*#__PURE__*/_jsx("span", {
        style: {
          color: showError ? CANDY_APPLE : EERIE
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trellisEcosystem.reviews.minimum",
          options: {
            limit: minCharacters
          }
        })
      });
    }
    if (maxCharacters) {
      return /*#__PURE__*/_jsx("span", {
        style: {
          color: showError ? CANDY_APPLE : EERIE
        },
        children: maxCharacters - count
      });
    }
  };
  if (!maxCharacters && !minCharacters) {
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: label,
      required: required,
      tooltip: tooltip,
      tooltipPlacement: "right",
      children: renderTextArea({
        value: review.content[fieldKey] || ''
      })
    });
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: label,
    required: required,
    tooltip: tooltip,
    tooltipPlacement: "right",
    children: /*#__PURE__*/_jsx(UICharacterCounter, {
      renderInput: ({
        onChange,
        value
      }) => renderTextArea({
        onChange,
        value
      }),
      label: ({
        count
      }) => renderCharacterCounterLabel(count),
      value: review.content[fieldKey] || ''
    })
  });
}